import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, useLocation, Outlet } from 'react-router-dom';

import RouteWrapper from './route'; 
import Authorized from '../pages/Layouts/Authorized'; // O seu componente de Layout

import Login from '../pages/Login';
import Home from '../pages/Home';
import PanelErp from '../pages/Panel/PanelErp';
import PanelErpScreens from '../pages/Panel/PanelErpScreens';
import PanelComercial from '../pages/Panel/PanelComercial/PanelComercial';
import PanelFinances from '../pages/Panel/PanelFinances'
import SQLServerMonitorPage from '../pages/Panel/Db/SQLServerMonitorPanel';
import MySQLMonitorPanel from '../pages/Panel/Db/MySQLMonitorPanel'
import MongoMonitorPanel from '../pages/Panel/Db/MongoMonitorPanel';


const LayoutWithScroll = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [pathname]);

    return <Authorized />;
};

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: <RouteWrapper />,
    children: [
      {
        element: <LayoutWithScroll />,
        children: [
          {
            path: '/',
            element: <Home />,
          },
          {
            path: '/panel/erp',
            element: <PanelErp />,
          },
          {
            path: '/panel/erp/screens',
            element: <PanelErpScreens />,
          },
          {
            path: '/panel/erp/comercial',
            element: <PanelComercial/>,
          },
          {
            path: '/panel/erp/financeiro',
            element: <PanelFinances/>,
          },
          {
            path: '/monitor/sql-server',
            element: <SQLServerMonitorPage />,
          },
          {
            path: '/monitor/mysql',
            element: <MySQLMonitorPanel />,
          },
          {
            path: '/monitor/mongodb', 
            element: <MongoMonitorPanel />,
          },
        ],
      },
    ],
  },
]);

const RoutesList = () => {
  return <RouterProvider router={router} />;
};

export default RoutesList;